import { ReactElement, useCallback, useEffect, useMemo, useState } from "react";
import { Card, Flex, Text, Grid, AgGridReact, AgGrid } from "@jsq/ds/core";
import { LoadingCellRenderer } from "~/pages/Billing/components/LoadingCellRenderer";
import { PAGINATION } from "~/pages/Billing/constants";
import { getRowId, sideBarDef, updateGridDataSource } from "~/pages/Billing/gridUtils";
import { ClientLogGraphqlDataSource } from "./clientLogGraphqlDataSource";
import { getColumnDefinitions } from "./columnDefinitions";
import { logCard, logCardContent, logHeading } from "./styles_vanilla.css";

const colDefs = getColumnDefinitions();

type LogTabProps = {
  clientId: number;
  arenaId: number | null;
};

export const LogTab = ({ clientId, arenaId }: LogTabProps): ReactElement => {
  const [gridApi, setGridApi] = useState<AgGrid.GridApi>();

  const dataSource = useMemo(
    () => new ClientLogGraphqlDataSource(clientId, arenaId),
    [clientId, arenaId],
  );

  useEffect(() => {
    updateGridDataSource(gridApi, dataSource);
  }, [gridApi, dataSource]);

  const handleOnGridReady = useCallback((event: AgGrid.GridReadyEvent) => {
    setGridApi(event.api);
  }, []);

  const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
    autoSizeStrategy: {
      type: "fitGridWidth",
    },
    rowHeight: 48,
    suppressCellFocus: true,
    sideBar: sideBarDef,
    domLayout: "normal",
    rowModelType: "serverSide",
    getRowId,
    pagination: true,
    paginationPageSizeSelector: false,
    cacheBlockSize: PAGINATION.CASES_PAGE_SIZE,
    paginationPageSize: PAGINATION.CASES_PAGE_SIZE,
    onGridReady: handleOnGridReady,
    defaultColDef: {
      flex: 1,
    },
  };

  return (
    <Flex flexGrow={1}>
      <Card className={logCard}>
        <Flex flexDirection="column" flexGrow={1} className={logCardContent}>
          <Text variant="h3" className={logHeading}>
            Log
          </Text>
          <Flex flexGrow={1}>
            <Grid
              gridOptions={gridOptions}
              columnDefs={colDefs}
              loadingCellRenderer={LoadingCellRenderer}
            />
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};
